document.addEventListener('DOMContentLoaded', function() {
    const contractTypeSelect = document.getElementById('contract_type');
    const startedAtInput = document.getElementById('started_at');
    const confirmButton = document.getElementById('confirm-contract');

    // 契約フォームが存在する場合のみ処理を実行
    if (contractTypeSelect && startedAtInput && confirmButton) {
        // 入力値の検証とボタンの有効/無効を制御
        function validateInputs() {
            const contractType = contractTypeSelect.value;
            const startedAt = startedAtInput.value;

            if (contractType && startedAt) {
                confirmButton.disabled = false;
            } else {
                confirmButton.disabled = true;
            }
        }

        // 入力値変更時にバリデーションを実行
        contractTypeSelect.addEventListener('change', validateInputs);
        startedAtInput.addEventListener('change', validateInputs);

        // モーダル表示時に入力内容を確認表示に反映
        const showModalButtons = document.querySelectorAll('[command="show-modal"]');
        showModalButtons.forEach(button => {
            button.addEventListener('click', function() {
                const contractType = contractTypeSelect.value;
                const startedAt = startedAtInput.value;

                // モーダル内の表示を更新
                let contractTypeText = '未選択';
                let formattedDate = '未選択';

                if (contractType) {
                    if (contractType === 'lecturer') {
                        contractTypeText = '講師';
                    } else if (contractType === 'career_consultant') {
                        contractTypeText = 'キャリアコンサルタント';
                    } else {
                        contractTypeText = '不明';
                    }
                }

                if (startedAt) {
                    const date = new Date(startedAt);
                    if (!isNaN(date.getTime())) {
                        formattedDate = `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
                    }
                }

                document.getElementById('modal-contract-type').textContent = contractTypeText;
                document.getElementById('modal-started-at').textContent = formattedDate;

                // ボタンの状態を更新
                validateInputs();
            });
        });

        // 契約作成確定ボタンのイベント
        confirmButton.addEventListener('click', function() {
            if (!confirmButton.disabled) {
                document.getElementById('contractForm').submit();
            }
        });

        // 初期状態でのバリデーション
        validateInputs();
    }
});
